import { Link } from 'react-router-dom';
import { articles } from '@/mocks/categories';

export default function ArticleCardsSection() {
  return (
    <section id="artykuly" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-3">Poradniki zakupowe</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Kakobuy Spreadsheet – Artykuły i poradniki
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Poznaj szczegółowe przewodniki po kategoriach, strategie zakupowe, analizy QC i wiele więcej. Wszystko, czego potrzebujesz aby świadomie korzystać z Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200 hover:border-primary-200 transition-all duration-200 overflow-hidden cursor-pointer"
            >
              <div className="w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="px-2.5 py-0.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full">{article.tag}</span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center gap-2 mt-4 text-sm font-medium text-primary-500">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/kakobuy-spreadsheet-poradnik"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm shadow-sm hover:shadow-md"
          >
            <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
            Zobacz kompletny przewodnik
          </Link>
        </div>
      </div>
    </section>
  );
}